import { Alert, Autocomplete, Box, Button, Card, CardActions, CardMedia, Container, Grid2, Icon, Link, Paper, Select, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import { LocationCity, LocationOn, Map } from "@mui/icons-material";

export default function OrderNow() {

    const navigate = useNavigate();

    function onOrderNow() {
        navigate("/order-now-step1");
    }
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: (theme ?? theme).palette.text.secondary,
        ...theme.applyStyles('dark', {
            backgroundColor: '#1A2027',
        }),
    }));


    return (
        <Container>
            <Card sx={{ textAlign: "center", background: "#FEF9F8", marginX: "auto", width: "100%", boxShadow: "none", marginTop:{ xs: 10, sm: 10, md: 10}}}>
                <CardMedia sx={{ height: {xs:300, sm:550, md:550, lg:650}, marginBottom: 3 }} image="lpg-delivery.jpg" />

                {/* <Grid2 container spacing={2}>
                    <Grid2 size={{ xs:12, sm:12, md:4, lg:4 }}>
                        <Item sx={{ fontWeight: 'bold', alignItems: "flex-end", justifyContent: "center",  display: "flex" }}><LocationOn color="primary"></LocationOn> Quezon City</Item>
                    </Grid2>
                    <Grid2 size={{ xs:12, sm:12, md:4, lg:4 }}>
                        <Item sx={{ fontWeight: 'bold', alignItems: "flex-end", justifyContent: "center",  display: "flex" }}><LocationOn color="warning"></LocationOn> Marikina City</Item>
                    </Grid2>
                    <Grid2 size={{ xs:12, sm:12, md:4, lg:4 }}>
                        <Item sx={{ fontWeight: 'bold', alignItems: "flex-end", justifyContent: "center",  display: "flex" }}><LocationOn color="success"></LocationOn> San Mateo, Rizal</Item>
                    </Grid2>
                </Grid2> */}

                <Grid2 container spacing={2} sx={{fontSize: {xs: 12, sm: 12, md: 14}, fontFamily: "Roboto, Helvetica,Arial, sans-serif"}}>
                    <Grid2 size={{ xs:4, sm:4, md:4, lg:4 }} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <LocationOn color="primary"></LocationOn> Quezon City
                    </Grid2>
                    <Grid2 size={{ xs:4, sm:4, md:4, lg:4 }} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <LocationOn color="warning"></LocationOn> Marikina City
                    </Grid2>
                    <Grid2 size={{ xs:4, sm:4, md:4, lg:4 }} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <LocationOn color="success"></LocationOn> San Mateo
                    </Grid2>
                </Grid2>

                <CardActions sx={{ display: "flex", justifyContent: "center", marginBottom: 1, marginTop: 3, paddingX: 0 }}>

                    <Button variant="contained" sx={{ background: "#d32f2f", width:{ xs: '100%', sm: '100%', md: 'auto' } }} onClick={onOrderNow} size="large">GUSTO KO MAGPADELIVER</Button>
                </CardActions>

            </Card>
        </Container>
    );
}
